module.exports = __webpack_public_path__ + "img/pro-xtslider4.ac8d1291.png";